/** Stripe Connect account id label for chrome (TopBar, Sidebar). */
export function formatConnectedAccount(id: string | null | undefined): string {
  if (!id?.startsWith("acct_")) {
    return "Not connected";
  }
  return id;
}

export function connectedAccountTitle(id: string | null | undefined): string | undefined {
  return id?.startsWith("acct_") ? id : undefined;
}
